var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "customer-information-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-document" }),
              _c("span", { staticClass: "header-title" }, [
                _vm._v("Cấu hình thông tin S-Invoice"),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "customer-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "150px",
                "label-position": "right",
              },
            },
            [
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _c("i", { staticClass: "el-icon-user" }),
                _c(
                  "span",
                  { staticStyle: { "font-weight": "bold", color: "#409EFF" } },
                  [_vm._v("Thông tin đăng nhập")]
                ),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tài khoản đăng nhập",
                            prop: "username",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              placeholder: "Nhập tài khoản đăng nhập Sinvoice",
                              maxlength: "100",
                              "show-word-limit": "",
                              clearable: "",
                              "prefix-icon": "el-icon-user",
                            },
                            model: {
                              value: _vm.formData.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "username", $$v)
                              },
                              expression: "formData.username",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mật khẩu", prop: "password" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "password",
                              autocomplete: "new-password",
                              placeholder: "Nhập mật khẩu",
                              maxlength: "100",
                              "show-password": "",
                              clearable: "",
                              "prefix-icon": "el-icon-lock",
                            },
                            model: {
                              value: _vm.formData.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "password", $$v)
                              },
                              expression: "formData.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _c("i", { staticClass: "el-icon-office-building" }),
                _c(
                  "span",
                  { staticStyle: { "font-weight": "bold", color: "#67C23A" } },
                  [_vm._v("Thông tin công ty/tổ chức")]
                ),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mã số thuế", prop: "taxCode" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Nhập mã số thuế",
                              maxlength: "100",
                              "show-word-limit": "",
                              clearable: "",
                              "prefix-icon": "el-icon-postcard",
                            },
                            model: {
                              value: _vm.formData.taxCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "taxCode", $$v)
                              },
                              expression: "formData.taxCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tên công ty/tổ chức",
                            prop: "companyName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Nhập tên công ty/tổ chức",
                              maxlength: "255",
                              "show-word-limit": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.companyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "companyName", $$v)
                              },
                              expression: "formData.companyName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Tên ngân hàng", prop: "bankName" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "Chọn ngân hàng",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function ({ label }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            gap: "8px",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: { width: "20px" },
                                            attrs: {
                                              src: _vm.bankList.find(
                                                (b) => b.name === label
                                              )?.logo,
                                              alt: label || "bank-logo",
                                            },
                                          }),
                                          _c("span", [_vm._v(_vm._s(label))]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.formData.bankName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "bankName", $$v)
                                },
                                expression: "formData.bankName",
                              },
                            },
                            _vm._l(_vm.bankListSorted, function (bank) {
                              return _c(
                                "el-option",
                                {
                                  key: bank.code,
                                  attrs: { label: bank.name, value: bank.name },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        gap: "8px",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: { width: "50px" },
                                        attrs: {
                                          src: bank.logo,
                                          alt: bank.name || "bank-logo",
                                        },
                                      }),
                                      _c("span", [_vm._v(_vm._s(bank.name))]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Số tài khoản", prop: "bankAccount" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Nhập số tài khoản",
                              maxlength: "50",
                              "show-word-limit": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.bankAccount,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "bankAccount", $$v)
                              },
                              expression: "formData.bankAccount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Số điện thoại", prop: "phone" } },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              placeholder: "Nhập số điện thoại",
                              maxlength: "15",
                              "show-word-limit": "",
                              clearable: "",
                              "prefix-icon": "el-icon-phone",
                            },
                            model: {
                              value: _vm.formData.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "phone", $$v)
                              },
                              expression: "formData.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              placeholder: "Nhập email công ty",
                              maxlength: "100",
                              "show-word-limit": "",
                              clearable: "",
                              "prefix-icon": "el-icon-message",
                            },
                            model: {
                              value: _vm.formData.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "email", $$v)
                              },
                              expression: "formData.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Địa chỉ", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Nhập địa chỉ công ty/tổ chức",
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "address", $$v)
                      },
                      expression: "formData.address",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _c("i", { staticClass: "el-icon-lock" }),
                _c(
                  "span",
                  { staticStyle: { "font-weight": "bold", color: "#909399" } },
                  [_vm._v("Thông tin chứng thư số")]
                ),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Serial chứng thư",
                    prop: "certificateSerial",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      autocomplete: "new-password",
                      "show-password": "",
                      placeholder: "Nhập serial chứng thư (nếu có)",
                      maxlength: "255",
                      "show-word-limit": "",
                      clearable: "",
                      "prefix-icon": "el-icon-lock",
                    },
                    model: {
                      value: _vm.formData.certificateSerial,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "certificateSerial", $$v)
                      },
                      expression: "formData.certificateSerial",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Ký hóa đơn", prop: "usbDigitalSignature" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formData.usbDigitalSignature,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "usbDigitalSignature", $$v)
                        },
                        expression: "formData.usbDigitalSignature",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Ký USB"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Ký HSM"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _c("i", { staticClass: "el-icon-s-custom" }),
                _c(
                  "span",
                  { staticStyle: { "font-weight": "bold", color: "#E6A23C" } },
                  [_vm._v("Thông tin người đại diện")]
                ),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Họ tên",
                            prop: "representativeName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Nhập họ tên người đại diện",
                              maxlength: "100",
                              "show-word-limit": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.representativeName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "representativeName",
                                  $$v
                                )
                              },
                              expression: "formData.representativeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Chức vụ",
                            prop: "representativePosition",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Nhập chức vụ",
                              maxlength: "100",
                              "show-word-limit": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.representativePosition,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "representativePosition",
                                  $$v
                                )
                              },
                              expression: "formData.representativePosition",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Số điện thoại",
                            prop: "representativePhone",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              placeholder: "Nhập số điện thoại người đại diện",
                              maxlength: "15",
                              "show-word-limit": "",
                              clearable: "",
                              "prefix-icon": "el-icon-phone",
                            },
                            model: {
                              value: _vm.formData.representativePhone,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "representativePhone",
                                  $$v
                                )
                              },
                              expression: "formData.representativePhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Email",
                            prop: "representativeEmail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              placeholder: "Nhập email người đại diện",
                              maxlength: "100",
                              "show-word-limit": "",
                              clearable: "",
                              "prefix-icon": "el-icon-message",
                            },
                            model: {
                              value: _vm.formData.representativeEmail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "representativeEmail",
                                  $$v
                                )
                              },
                              expression: "formData.representativeEmail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Số giấy tờ",
                            prop: "representativeDocumentNumber",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "Nhập số giấy tờ (CMND/CCCD/Hộ chiếu)",
                              maxlength: "100",
                              "show-word-limit": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.representativeDocumentNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "representativeDocumentNumber",
                                  $$v
                                )
                              },
                              expression:
                                "formData.representativeDocumentNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Ngày sinh",
                            prop: "representativeBirthDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              placeholder: "Chọn ngày sinh",
                              format: "dd-MM-yyyy",
                              "value-format": "yyyy-MM-dd",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.representativeBirthDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "representativeBirthDate",
                                  $$v
                                )
                              },
                              expression: "formData.representativeBirthDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _c("i", { staticClass: "el-icon-setting" }),
                _c(
                  "span",
                  { staticStyle: { "font-weight": "bold", color: "#909399" } },
                  [_vm._v("Cấu hình bổ sung")]
                ),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Mẫu hóa đơn", prop: "templateCode" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex", gap: "8px" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "Chọn mẫu hóa đơn",
                                    clearable: "",
                                  },
                                  on: { change: _vm.onInvoiceTemplateChange },
                                  model: {
                                    value: _vm.formData.templateCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "templateCode",
                                        $$v
                                      )
                                    },
                                    expression: "formData.templateCode",
                                  },
                                },
                                _vm._l(
                                  _vm.invoiceTemplateOptions,
                                  function (opt) {
                                    return _c("el-option", {
                                      key: opt.value,
                                      attrs: {
                                        label: opt.label,
                                        value: opt.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Lấy danh sách mẫu hóa đơn",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "success",
                                      icon: "el-icon-download",
                                      loading: _vm.loading.sync,
                                    },
                                    on: {
                                      click: _vm.handleSyncInvoiceTemplateList,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, xs: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Ký hiệu hóa đơn",
                            prop: "invoiceSeries",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                placeholder: "Chọn ký hiệu hóa đơn",
                                clearable: "",
                              },
                              model: {
                                value: _vm.formData.invoiceSeries,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "invoiceSeries", $$v)
                                },
                                expression: "formData.invoiceSeries",
                              },
                            },
                            _vm._l(_vm.invoiceSeriesOptions, function (opt) {
                              return _c("el-option", {
                                key: opt.value,
                                attrs: { label: opt.label, value: opt.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Ghi chú", prop: "note" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "Nhập ghi chú (nếu có)",
                      maxlength: "1000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "note", $$v)
                      },
                      expression: "formData.note",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-check",
                        loading: _vm.loading.submit,
                      },
                      on: { click: _vm.submitForm },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.isEdit ? "Cập nhật" : "Lưu") +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        icon: "el-icon-connection",
                        loading: _vm.loading.test,
                      },
                      on: { click: _vm.testConnection },
                    },
                    [_vm._v("\n          Kiểm tra\n        ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning", icon: "el-icon-refresh" },
                      on: { click: _vm.resetForm },
                    },
                    [_vm._v("\n          Đặt lại\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }